<div ngModelGroup="plan">
    <div class="row" id="backend-admin-customer-plan">
        <div class="col-sm-offset-2 col-sm-40">
            <h5 translate>Subscription start date*</h5>
            <mon-form-field-datepicker
              datePickerInputName="subscription_start"
              [ngRequired]="true"
              [(model)]="customer.subscription.subscription_start_at"
              (modelChange)="setDate($event)"></mon-form-field-datepicker>
            <h5 translate>Subscription</h5>
            <mon-form-field-select 
                                           name="customer.subscription.plan_id"
                                           monName="customer.subscription.plan_id"
                                           [monOptions]="planOptions"
                                           monPlaceholder="{{ 'Subscriptions' | translate }}"
                                           [(model)]="customer.subscription.plan_id"
                                           monReturnValue="id"
                                           (modelChange)="onSelectPlan()">
            </mon-form-field-select>
            <h5 translate>Account status</h5>
            <mon-form-field-checkbox monName="customer.account_suspended"
                                     [(model)]="customer.account_suspended"
                                     monLabel="{{'Account suspended' | translate}}">
            </mon-form-field-checkbox>

            <div class="row">
                <div class="col-sm-48 inner-t-smurf">
                    <mon-switch [(ngModel)]="customer.subscription.test_customer"
                                class="inline-block outer-r-large outer-t-smurf pull-left"
                                monLabel="test_customer"
                                name="'test_customer'">
                    </mon-switch>
                    <label for="test_customer" class="font-weight-400 pl-2 mt-1 inner-t-smurf" translate>
                        Test customer
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-48 inner-t-smurf">
                    <mon-switch [(ngModel)]="customer.subscription.preview_customer"
                                class="inline-block outer-r-large outer-t-smurf pull-left"
                                monLabel="preview_customer"
                                name="'preview_customer'">
                    </mon-switch>
                    <label for="preview_customer" class="font-weight-400 pl-2 mt-1 inner-t-smurf" translate>
                        Preview customer
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
